module.exports = __webpack_public_path__ + "static/media/404.f2839f8f.svg";